import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { stages } from '@store/TimeAndMaterialData';

import * as styles from './HowWeWork.module.scss';
import { PageUrls } from '@utils/constants/PageUrls';
import { Link } from 'gatsby';

export const HowWeWork: React.FC = () => {
	return (
		<PaddingContainer className={classNames(styles.container, 'white-bg')}>
			<WidthContainer>
				<div className="row no-gutters">
					<div className="col-12 col-lg-6 mb-4 mb-lg-0">
						<h2 className="font-size-md font-600 mb-2">How we work?</h2>
						<p className="font-size-sm line-height-sm mb-4">
							We start with small steps that can further expand into a long-term
							cooperation. We only need your idea for the project, we will get
							the rest during the Design Phase.
						</p>
						<Link to={PageUrls.HOW_WE_WORK}>
							<button
								className={classNames(
									styles.readMore,
									'bttn bttn-orange-border py-2 px-3'
								)}
							>
								READ MORE
							</button>
						</Link>
					</div>
					<div className="col-12 col-lg-6">
						<div className={classNames(styles.stages, 'row no-gutters pt-4')}>
							{stages.map((stage) => (
								<div
									key={stage.title}
									className="col-12 col-sm-4 mt-5 mt-sm-0 d-flex flex-column align-items-center"
								>
									<img src={stage.icon} />
									<p className="font-size-14">{stage.title}</p>
								</div>
							))}
						</div>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
